// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3hztn","list":"BalanceDue_list__24MZz","listRow":"BalanceDue_listRow__1b2pw","total":"BalanceDue_total__1zy7T"};